import { combineReducers } from '@reduxjs/toolkit'

import countrySlice from './slices/countrySlice'
import bannerManagementSlice from './slices/bannerManagementSlice'
import productBasedRuleSlice from './slices/productBasedRuleSlice'
import productMasterDataSlice from './slices/productMasterDataSlice'
import portalUserManagementSlice from './slices/portalUserManagementSlice'
import memberListSlice from './slices/memberListSlice'
import configurationSlice from './slices/configurationSlice'
import memberListNotificationSlice from './slices/memberListNotificationSlice'
import rolesAndAccessSlice from './slices/rolesAndAccessSlice'
import tierMasterDataSlice from './slices/tierMasterDataSlice'
import transactionSlice from './slices/transactionSlice'
import sidebarSlice from './slices/sidebarSlice'
import tableSlice from './slices/tableSlice'
import toastSlice from './slices/toastSlice'
import bootStrapSlice from './slices/bootStrapSlice'
import redemptionSlice from './slices/redemptionSlice'
import campaignUserDataSlice from './slices/campaignUserDataSlice'
import campaignManagementSlice from './slices/campaignManagementSlice'
import exportSlice from './slices/exportSlice'
import campaignLuckyDrawWinnersSlice from './slices/campaignLuckyDrawWinnersSlice'
import cashbackRuleSlice from './slices/cashbackRuleSlice'
import analyticsSlice from './slices/analyticsSlice'
import geoLocationMasterDataSlice from './slices/geoLocationMasterDataSlice'

const createReducer = (asyncReducers) =>
  combineReducers({
    bootstrap: bootStrapSlice,
    sidebar: sidebarSlice,
    table: tableSlice,
    country: countrySlice,
    configuration: configurationSlice,
    bannerManagement: bannerManagementSlice,
    productBasedRule: productBasedRuleSlice,
    cashbackRule: cashbackRuleSlice,
    productMasterData: productMasterDataSlice,
    tierMasterData: tierMasterDataSlice,
    transaction: transactionSlice,
    portalUserManagement: portalUserManagementSlice,
    memberList: memberListSlice,
    memberListNotification: memberListNotificationSlice,
    rolesAndAccess: rolesAndAccessSlice,
    toast: toastSlice,
    redemption: redemptionSlice,
    campaignUserData: campaignUserDataSlice,
    campaignManagement: campaignManagementSlice,
    exports: exportSlice,
    luckyDrawWinnersData: campaignLuckyDrawWinnersSlice,
    analytics: analyticsSlice,
    geoLocationMasterData: geoLocationMasterDataSlice,
    ...asyncReducers,
  })

export default createReducer
